export default __webpack_public_path__ + "bd5ff75.png";